module.exports = __webpack_public_path__ + "static/media/basel-33.f8f4cb6e.jpg";